import React from 'react';
import i18next from 'i18next';

function What() {
    return (
        <>
            {i18next.language === 'ar' ? (
                <>
                    <h3 id='title'>ماهو اضطراب طيف التوحد</h3>
                    <p>
                        هو اضطراب نمائي تشمل أعراضه الأساسية على صعوبات في
                        التواصل والتفاعل الاجتماعي وأنماط تكرارية و محدودة من
                        السلوكيات.
                    </p>
                    <h3 id='title'>معدل انتشار اضطراب طيف التوحد حول العالم</h3>
                    <p id='list'>
                        وفقاً لمنظمة الصحة العالمية: طفل من كل ١٦٠ طفل حول
                        العالم مصاب باضطراب طيف التوحد. ووفقاً لمركز التحكم
                        بالأمراض والوقاية منها الأمريكي (CDC) فإن معدل انتشار
                        اضطراب طيف التوحد في الولايات المتحدة الأمريكية:
                    </p>
                    <ul>
                        <li>
                            في عام ٢٠٢٠م (طفل من كل ٥٤ طفل) مصاب باضطراب طيف
                            التوحد.
                        </li>
                        <li id='last'>
                            في عام ٢٠١٨م (طفل من كل ٥٩ طفل) مصاب باضطراب طيف
                            التوحد.
                        </li>
                    </ul>
                    <h4 id='title'>السبب في زيادة انتشار اضطراب طيف التوحد</h4>
                    <ol>
                        <li>
                            المعايير التشخيصية أصبحت مرنة بشكل أكثر. حيث أن
                            النسخة الخامسة من &quot;الدليل التشخيصي والإحصائي
                            للاضطرابات النفسية&quot; DSM-5 دمج متلازمة أسبرجر و
                            اضطرابات النمو الشاملة -الغير محددة PDD-NOS والتوحد
                            القديم في مصطلح واحد هو &quot;اضطراب طيف
                            التوحد&quot;.
                        </li>
                        <li>
                            انتشار البرامج المسحية مثل اختبار قائمة استبيان
                            التوحد عند الأطفال M-CHAT (من عمر ١٦ إلى ٣٠ شهراً)
                            للكشف وتحديد خطر الاصابة في اضطراب طيف التوحد و يتم
                            خلال المواعيد الدورية للأطفال الصغار.
                        </li>
                        <li>زيادة الوعي في المجتمع باضطراب طيف التوحد.</li>
                        <li id='last'>
                            في الماضي ربما تم تشخيص العديد من الأفراد الذين
                            لديهم توحد بتشخيصات أخرى خاطئة مثل الإعاقة الذهنية:
                            لأنه مع ارتفاع تشخيص التوحد، انخفض تشخيص الإعاقة
                            الذهنية.
                        </li>
                    </ol>
                </>
            ) : (
                <>
                    <h3 id='-'>What is Autism </h3>
                    <p>
                        Autism is a developmental disorder condition,
                        characterized by challenges with verbal and nonverbal
                        communication, social skills, repetitive behaviors.{' '}
                    </p>
                    <h3 id='-'>Autism Prevalence</h3>
                    <p>
                        The World Health Organization estimated that one in 160
                        children worldwide has Autism. According to the Centers
                        for Disease Control and Prevention:{' '}
                    </p>
                    <ul>
                        <li>
                            In 2020, the CDC reported that approximately 1 in 54
                            children in the U.S. is diagnosed with an autism
                            spectrum disorder
                        </li>
                        <li>
                            In 2018, it reported that approximately 1 in 59
                            children in the U.S. is diagnosed with an autism
                            spectrum disorder
                        </li>
                    </ul>
                    <h4 id='-'>
                        Why has the autism prevalence been increasing?
                    </h4>
                    <ol>
                        <li>
                            In the DSM-5, Autism encompasses of Asperger
                            syndrome, PDD-NOS and classic autism
                        </li>
                        <li>
                            The spread of screening Programs (M-CHAT) for autism
                            during children's routine pediatrician visits at 18
                            and 24 months of age
                        </li>
                        <li>Increased awareness of autism in the community</li>
                        <li id='last'>
                            In the past, many individuals with autism may have
                            been diagnosed with other wrong diagnoses such as
                            intellectual disability: because as the diagnosis of
                            autism rises, the diagnosis of intellectual
                            disability decreases.
                        </li>
                    </ol>
                </>
            )}
        </>
    );
}

export default What;
